// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FunctionOutlinedSvg from "@ant-design/icons-svg/es/asn/FunctionOutlined";
import AntdIcon from '../components/AntdIcon';

var FunctionOutlined = function FunctionOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FunctionOutlinedSvg
  }));
};

FunctionOutlined.displayName = 'FunctionOutlined';
export default React.forwardRef(FunctionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FunctionOutlined.js
// module id = 1233
// module chunks = 0